<template>
  <div v-if="show && holeRect" class="submit-audit-guide-root">
    <div class="submit-audit-guide-strip" :style="stripTopStyle" @click.stop />
    <div class="submit-audit-guide-strip" :style="stripBottomStyle" @click.stop />
    <div class="submit-audit-guide-strip" :style="stripLeftStyle" @click.stop />
    <div class="submit-audit-guide-strip" :style="stripRightStyle" @click.stop />
    <div class="submit-audit-guide-connector" :style="connectorStyle" aria-hidden="true" />
    <div
      class="submit-audit-guide-bubble"
      :style="[bubbleOuterStyle, { background: bubbleBg }]"
    >
      <p class="submit-audit-guide-text">{{ message }}</p>
      <button
        type="button"
        class="submit-audit-guide-btn"
        :style="{ color: btnColor }"
        @click="$emit('dismiss')"
      >
        我知道了
      </button>
    </div>
  </div>
</template>

<script>
/**
 * 报名单页首次进入：高亮「提交审核」按钮 + 文案气泡（蒙层镂空）
 * 是否展示由父页面 tryShowSubmitAuditGuide 控制；「我知道了」须按队伍写入 localStorage（key 含 teamId），
 * 避免同赛事新建另一支球队时不弹。
 */
export default {
  name: 'EntrySubmitAuditGuide',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    holeRect: {
      type: Object,
      default: null
    },
    viewport: {
      type: Object,
      default: () => ({ w: 0, h: 0 })
    },
    jetlympic: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: '参赛资料确认无误后，记得「提交审核」'
    }
  },
  computed: {
    bubbleBg() {
      return this.jetlympic ? '#00A7FF' : '#1989fa'
    },
    btnColor() {
      return this.jetlympic ? '#00A7FF' : '#1989fa'
    },
    lineH() {
      return 18
    },
    stripTopStyle() {
      const r = this.holeRect
      if (!r) return {}
      return { top: '0', left: '0', width: '100%', height: `${r.top}px` }
    },
    stripBottomStyle() {
      const r = this.holeRect
      const v = this.viewport
      if (!r || !v.h) return {}
      const h = Math.max(0, v.h - r.top - r.height)
      return { top: `${r.top + r.height}px`, left: '0', width: '100%', height: `${h}px` }
    },
    stripLeftStyle() {
      const r = this.holeRect
      if (!r) return {}
      return { top: `${r.top}px`, left: '0', width: `${r.left}px`, height: `${r.height}px` }
    },
    stripRightStyle() {
      const r = this.holeRect
      const v = this.viewport
      if (!r || !v.w) return {}
      const w = Math.max(0, v.w - r.left - r.width)
      return {
        top: `${r.top}px`,
        left: `${r.left + r.width}px`,
        width: `${w}px`,
        height: `${r.height}px`
      }
    },
    connectorStyle() {
      const r = this.holeRect
      if (!r) return {}
      const lh = this.lineH
      const cx = r.left + r.width / 2
      return {
        position: 'fixed',
        left: `${cx - 1}px`,
        top: `${r.top - lh}px`,
        width: '2px',
        height: `${lh}px`,
        zIndex: 10001,
        pointerEvents: 'none'
      }
    },
    bubbleOuterStyle() {
      const r = this.holeRect
      if (!r) return {}
      const lh = this.lineH
      return {
        position: 'fixed',
        left: '50%',
        top: `${r.top - lh}px`,
        transform: 'translate(-50%, -100%)',
        width: 'calc(100vw - 32px)',
        maxWidth: '320px',
        zIndex: 10001
      }
    }
  }
}
</script>

<style scoped lang="scss">
.submit-audit-guide-root {
  position: fixed;
  inset: 0;
  z-index: 10000;
  pointer-events: none;
}

.submit-audit-guide-strip {
  position: fixed;
  background: rgba(0, 0, 0, 0.55);
  pointer-events: auto;
}

.submit-audit-guide-connector {
  background: #fff;
  border-radius: 1px;
}

.submit-audit-guide-bubble {
  pointer-events: auto;
  border-radius: 10px;
  padding: 16px 16px 14px;
  box-sizing: border-box;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.submit-audit-guide-text {
  margin: 0;
  font-size: 15px;
  line-height: 22px;
  color: #fff;
  text-align: left;
}

.submit-audit-guide-btn {
  display: block;
  margin-top: 14px;
  margin-left: auto;
  padding: 7px 20px;
  font-size: 14px;
  font-weight: 500;
  background: #fff;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
</style>
